// @flow

import * as React from 'react';
import {isEqual} from 'lodash';
import {Page} from 'docs/components';
import {useActivePage} from 'docs/hooks';
import './Document.scss';

type DocumentProps = {|
  children: React.Node,
|};

export const Document = ({children}: DocumentProps) => {
  const activePage = useActivePage();

  // If the Document contains Page components, only show the one that
  // matches the currently-selected active page. This is slightly different
  // than a ContentGroup because we want to show all items which aren't
  // inside of a Page regardless of the active page.
  const content = React.Children.toArray(children).filter(
    (child) =>
      child.type !== Page || isEqual(child.props.prefs, activePage.prefs),
  );

  return <div className="Document">{content}</div>;
};
